import cn from 'classnames'
import * as React from 'preact/compat'

import SVG from '#components/SVG'
import type { SearchItemProps } from '#components/Search/SearchPanel'

import styles from '#css/search-panel.pcss.json'

// noinspection ES6UnusedImports

export default ({ item }: SearchItemProps) => {
  return <a href={item.url} className={cn(styles['game-card'], styles['game-card--series'])}>
    <div className={styles['game-card__top']}>
      <img alt={item.title} src={item.square_poster} className={styles['game-card__poster']}/>
      <span className={styles['game-card__games-count']}>
        <SVG i='sg/gamepad-solid'/> {item.games_count}
      </span>
    </div>
    <div className={styles['game-card__bottom']}>
      <div>
        <p class={styles['game-card__series-title']}>Серия игр</p>
        <h3 className={styles['game-card__title']}>{item.title}</h3>
      </div>
      <div>
        <p className={styles['game-card__date']}>{item.games_years}</p>
      </div>
    </div>
  </a>
}
